/** Date / time / number formatting helpers. */
/** "5m ago" for a past instant, "in 5m" for a future one — a session's expiry
 *  is in the future, and the past-only form rendered it as "-23708755s ago". */
export function formatRelativeTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const seconds = Math.round((Date.now() - d.getTime()) / 1000);
  const span = formatSpan(Math.abs(seconds));
  return seconds < 0 ? `in ${span}` : `${span} ago`;
}

/** A non-negative number of seconds in its largest whole unit: 45s, 5m, 3h, 12d. */
function formatSpan(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.round(hours / 24)}d`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}
